/** 기획전(Promotion) 공용 유틸 */

/**
 * 기획전 컬럼 문자열을 기획전명 배열로 분리한다.
 *
 * RCT_S_가격예약_02 계열 SP는 날짜별 기획전을 `STRING_AGG(기획전명, ',')` 로만 내려준다
 * (기획전번호는 없다). 기획전명 자체에 콤마가 들어 있으면 과다 분리되므로,
 * 이 함수의 결과는 표시(배지·툴팁)나 역매핑 "입력"으로만 쓰고,
 * 번호가 필요한 로직에서는 사전 역매핑 후 확정 여부를 반드시 검사해야 한다.
 */
export const splitPromoNames = (promo) => String(promo ?? '')
  .split(',')
  .map((s) => s.trim())
  .filter(Boolean);

export default { splitPromoNames };
